import { render, staticRenderFns } from "./CoCollapsible.vue?vue&type=template&id=460e9bc9&scoped=true&"
import script from "./CoCollapsible.vue?vue&type=script&lang=ts&"
export * from "./CoCollapsible.vue?vue&type=script&lang=ts&"
import style0 from "./CoCollapsible.vue?vue&type=style&index=0&id=460e9bc9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e9bc9",
  null
  
)

export default component.exports